import { loadScript } from 'dashboard/helper/DOMHelpers';

export const loadFacebookSdk = async () => {
  return loadScript('https://connect.facebook.net/en_US/sdk.js', {
    async: true,
    defer: true,
    crossOrigin: 'anonymous',
  });
};

export const initializeFacebook = (appId, apiVersion) => {
  const version = apiVersion || 'v25.0';
  return new Promise((resolve, reject) => {
    // Timeout to avoid infinite wait
    const timeout = setTimeout(() => {
      reject(new Error('Facebook SDK initialization timeout'));
    }, 10000);

    const init = () => {
      try {
        if (!window.FB) {
          clearTimeout(timeout);
          reject(new Error('Facebook SDK not loaded'));
          return;
        }

        window.FB.init({
          appId,
          autoLogAppEvents: true,
          xfbml: true,
          version,
        });

        // Wait a bit for the SDK to be fully initialized
        setTimeout(() => {
          clearTimeout(timeout);
          resolve();
        }, 100);
      } catch (error) {
        clearTimeout(timeout);
        reject(error);
      }
    };

    if (window.FB) {
      init();
    } else {
      window.fbAsyncInit = init;
    }
  });
};

export const isValidBusinessData = businessData => {
  return businessData && businessData.business_id && businessData.waba_id;
};

export const createMessageHandler = onEmbeddedSignupData => {
  return event => {
    if (!event.origin.endsWith('facebook.com')) return;

    try {
      let data;
      if (typeof event.data === 'string') {
        data = JSON.parse(event.data);
      } else if (typeof event.data === 'object' && event.data !== null) {
        data = event.data;
      } else {
        return;
      }

      if (data.type === 'WA_EMBEDDED_SIGNUP') {
        onEmbeddedSignupData(data);
      }
    } catch {
      // Ignore non-JSON or irrelevant messages
    }
  };
};

export const initWhatsAppEmbeddedSignup = configId => {
  return new Promise((resolve, reject) => {
    // Check if the FB SDK is loaded and initialized
    if (!window.FB) {
      reject(new Error('Facebook SDK not loaded'));
      return;
    }

    try {
      window.FB.login(
        response => {
          if (response.authResponse && response.authResponse.code) {
            resolve(response.authResponse.code);
          } else if (response.error) {
            reject(new Error(response.error));
          } else {
            reject(new Error('Login cancelled'));
          }
        },
        {
          config_id: configId,
          response_type: 'code',
          override_default_response_type: true,
          extras: {
            setup: {},
            featureType: 'whatsapp_business_app_onboarding',
            sessionInfoVersion: '4',
          },
        }
      );
    } catch (error) {
      reject(error);
    }
  });
};

export const setupFacebookSdk = async (appId, apiVersion) => {
  const version = apiVersion || 'v25.0';
  await loadFacebookSdk();
  await initializeFacebook(appId, version);
};
